import {
  deleteCleaningSchedule,
  getCleaningRoster,
  sendCleaningSchedule,
} from './cleaningScheduleApi';
import {
  deleteShiftRoster,
  getShiftRoster,
  sendShiftData,
} from '../ShiftManagement/ShiftShedule_Api_service';

const SHIFT_LABELS = {
  previewBanner: null,
  instructionSelectSite: 'Please search and select the site to assign a shift',
  pickDateTitle: 'Pick date or Date range to assign shift',
  pastDateWarning: 'You cannot schedule shifts for previous dates. Please select today or a future date.',
  pastDateRangeWarning:
    'You cannot schedule shifts for previous dates. Please select today or a future date for both start and end dates.',
  loadingSlots: siteName => `Loading shifts for ${siteName}...`,
  slotTab: index => `Shift - ${index}`,
  defaultSlotTab: 'Shift - 1',
  addSlot: 'Add Shift',
  slotTimeTitle: index =>
    `Shift - ${index}, Please select the time range`,
  defaultSlotTimeTitle: 'Shift - 1, Please select the time range',
  nightShiftTitle: 'Night Shift',
  scheduleSuccess: 'Shift scheduled successfully!',
  scheduleButton: 'Schedule Shift',
  scheduleButtonLoading: 'Scheduling...',
  summaryTitle: 'Shift Summary',
  cannotSchedulePast: 'Cannot schedule shifts for previous dates. Please select today or a future date.',
  assignBeforeSchedule: 'Please assign at least one employee before scheduling the shift',
  addSlotBlockedIntro:
    'You cannot create a new shift until you fill and save the existing shift completely.\n\n',
  addSlotSetTimes: '• Set the shift start and end times\n',
  addSlotAssignStaff: '• Add at least one supervisor or guard\n',
  addSlotSave: "• Click 'Schedule Shift' to save the shift\n",
  alertSuccessTitle: operation => `Shift ${operation} successfully!`,
  alertErrorPrefix: 'Error scheduling shift',
  logViewEvent: 'shift_view',
  logScheduleEvent: 'shift_schedule',
  logScreenName: 'ScheduleShift',
};

const CLEANING_LABELS = {
  previewBanner: null,
  instructionSelectSite:
    'Please search and select the site to schedule a community shift',
  pickDateTitle: 'Pick date or select multiple dates',
  pastDateWarning:
    'You cannot schedule a community shift for previous dates. Please select today or a future date.',
  pastDateRangeWarning:
    'You cannot schedule a community shift for previous dates. Please select today or a future date for both start and end dates.',
  loadingSlots: siteName => `Loading shifts for ${siteName}...`,
  slotTab: index => `Shift - ${index}`,
  defaultSlotTab: 'Shift - 1',
  addSlot: 'Add Shift',
  slotTimeTitle: index =>
    `Shift - ${index}, Please select the time range`,
  defaultSlotTimeTitle: 'Shift - 1, Please select the time range',
  nightShiftTitle: 'Night Shift',
  scheduleSuccess: 'Community shift scheduled successfully!',
  scheduleButton: 'Schedule community shift',
  scheduleButtonLoading: 'Scheduling community shift...',
  summaryTitle: 'Shift Summary',
  cannotSchedulePast:
    'Cannot schedule a community shift for previous dates. Please select today or a future date.',
  assignBeforeSchedule:
    'Please assign at least one employee before scheduling a community shift',
  addSlotBlockedIntro:
    'You cannot create a new shift until you fill and save the existing shift completely.\n\n',
  addSlotSetTimes: '• Set the shift start and end times\n',
  addSlotAssignStaff: '• Add at least one employee\n',
  addSlotSave: "• Click 'Schedule community shift' to save the shift\n",
  alertSuccessTitle: operation => `Community shift ${operation} successfully!`,
  alertErrorPrefix: 'Error scheduling community shift',
  logViewEvent: 'cleaning_schedule_view',
  logScheduleEvent: 'cleaning_schedule_save',
  logScreenName: 'ScheduleACleaning',
};

export const SCHEDULE_MODES = {
  shift: {
    labels: SHIFT_LABELS,
    showZoneAssignment: true,
    getRoster: getShiftRoster,
    sendSchedule: sendShiftData,
    deleteSchedule: deleteShiftRoster,
  },
  cleaning: {
    labels: CLEANING_LABELS,
    showZoneAssignment: false,
    getRoster: getCleaningRoster,
    sendSchedule: sendCleaningSchedule,
    deleteSchedule: deleteCleaningSchedule,
  },
};

export const getScheduleModeConfig = (mode = 'shift') =>
  SCHEDULE_MODES[mode] || SCHEDULE_MODES.shift;
